import { FlagIcon } from '../../atoms/icons/flags';
import { useTranslation } from 'react-i18next';

export const sepaCountries = () => {
    const { t } = useTranslation();

    return [
        { value: 'AT', label: {icon: <FlagIcon.Austria />, key: t('countries.austria') }},
        { value: 'BE', label: {icon: <FlagIcon.Belgium />, key: t('countries.belgium')}},
        { value: 'BG', label: {icon: <FlagIcon.Bulgaria />, key: t('countries.bulgaria')}},
        { value: 'HR', label: {icon: <FlagIcon.Croatia />, key: t('countries.croatia')}},
        { value: 'CY', label: {icon: <FlagIcon.Cyprus />, key: t('countries.cyprus')}},
        { value: 'CZ', label: {icon: <FlagIcon.CzechRepublic />, key: t('countries.czechRepublic')}},
        { value: 'DK', label: {icon: <FlagIcon.Denmark />, key: t('countries.denmark')}},
        { value: 'NL', label: {icon: <FlagIcon.Dutch />, key: t('countries.netherlands')}},
        { value: 'FI', label: {icon: <FlagIcon.Finland />, key: t('countries.finland')}},
        { value: 'FR', label: {icon: <FlagIcon.France />, key: t('countries.france')}},
        { value: 'DE', label: {icon: <FlagIcon.Germany />, key: t('countries.germany')}},
        { value: 'GB', label: {icon: <FlagIcon.GreatBritain />, key: t('countries.greatBritain')}},
        { value: 'HU', label: {icon: <FlagIcon.Hungary />, key: t('countries.hungary')}},
        { value: 'IE', label: {icon: <FlagIcon.RepublicOfIreland />, key: t('countries.republicOfIreland')}},
        { value: 'IT', label: {icon: <FlagIcon.Italy />, key: t('countries.italy')}},
        { value: 'LU', label: {icon: <FlagIcon.Luxembourg />, key: t('countries.luxembourg')}},
        { value: 'MT', label: {icon: <FlagIcon.Malta />, key: t('countries.malta')}},
        { value: 'NO', label: {icon: <FlagIcon.Norway />, key: t('countries.norway')}},
        { value: 'PL', label: {icon: <FlagIcon.Poland />, key: t('countries.poland')}},
        { value: 'PT', label: {icon: <FlagIcon.Portugal />, key: t('countries.portugal')}},
        { value: 'RO', label: {icon: <FlagIcon.Romania />, key: t('countries.romania')}},
        { value: 'SK', label: {icon: <FlagIcon.Slovakia />, key: t('countries.slovakia')}},
        { value: 'SI', label: {icon: <FlagIcon.Slovenia />, key: t('countries.slovenia')}},
        { value: 'ES', label: {icon: <FlagIcon.Spain />, key: t('countries.spain')}},
        { value: 'SE', label: {icon: <FlagIcon.Sweden />, key: t('countries.sweden')}},
    ];
};
